// @flow @jsx h

import geojsonExtent from '@mapbox/geojson-extent'
import { Component, h } from 'preact'
import { geojsonTranslate } from './helpers'

import styles from './index.css'

type Props = {
  accessToken: string,
  fires: any | null,
  municipality: any | null,
  fireName: string | null
}

type State = {
  mapboxLoaded: boolean
}

const BBOX = [[4.7, 58], [31, 71.2]]

class SuggestSearch extends Component<Props, State> {
  elm: HTMLDivElement
  mapboxgl: any
  map: any

  state = {
    mapboxLoaded: false
  }

  componentDidMount () {
    this.initializeMap()
  }

  componentDidUpdate (prevProps: Props) {
    if (this.map && !prevProps.fires && this.props.fires) {
      this.drawFires()
    }

    if (this.map && !prevProps.municipality && this.props.municipality) {
      this.drawMunicipality()
      this.drawSelectedFire()
    }

    if (this.map && prevProps.municipality && this.props.municipality) {
      if (prevProps.municipality.id !== this.props.municipality.id) {
        this.drawMunicipality()
        this.drawSelectedFire()
      }
    }

    if (this.map && prevProps.fireName !== this.props.fireName) {
      this.drawSelectedFire()
    }
  }

  initializeMap () {
    window.require(
      ['https://api.mapbox.com/mapbox-gl-js/v0.47.0/mapbox-gl.js'],
      mapboxgl => {
        // console.log('[map]', 'mapboxgl.initialize')
        this.mapboxgl = mapboxgl
        this.mapboxgl.accessToken = this.props.accessToken

        this.map = new mapboxgl.Map({
          container: this.elm,
          style: 'mapbox://styles/nrk/cjf2taj8r1dnj2tk8hsd0mhaf'
          // zoomControl: true
        })

        // Setup controls
        this.map.addControl(
          new mapboxgl.NavigationControl({
            showCompass: false
          }),
          'top-left'
        )
        this.map.dragRotate.disable()
        this.map.touchZoomRotate.disableRotation()

        this.map.fitBounds(BBOX, {
          padding: { top: 10, bottom: 10, left: 10, right: 10 },
          duration: 0
        })

        this.map.on('load', () => {
          this.setState({ mapboxLoaded: true })
          // console.log('[map]', 'mapboxgl.load')

          this.drawFires()
          this.drawMunicipality()
          this.drawSelectedFire()
        })
      }
    )
  }

  drawFires () {
    if (!this.state.mapboxLoaded) {
      // console.log('[map]', 'could not draw fires')
      return
    }

    const data = this.props.fires

    // console.log('[map]', 'drawFires')

    if (data) {
      data.forEach((fire, idx) => {
        this.map.addLayer({
          id: `fire${String(idx)}`,
          type: 'fill',
          source: {
            type: 'geojson',
            data: fire.polygon
          },
          layout: {},
          paint: {
            'fill-color': '#E51C30',
            'fill-opacity': 0.8
          }
        })
      })
    }
  }

  drawMunicipality () {
    if (!this.state.mapboxLoaded) {
      // console.log('[map]', 'could not draw municipality')
      return
    }

    // console.log('[map]', 'drawMunicipality')

    const data = this.props.municipality

    if (data) {
      if (this.map.getLayer('municipality')) {
        this.map.removeLayer('municipality')
      }

      if (this.map.getSource('municipality')) {
        this.map.removeSource('municipality')
      }

      this.map.addLayer({
        id: 'municipality',
        type: 'line',
        source: {
          type: 'geojson',
          data: data.polygon
        },
        layout: {},
        paint: {
          'line-color': '#171A1B',
          'line-width': 2
        }
      })

      const bounds = new this.mapboxgl.LngLatBounds(geojsonExtent(data.polygon))

      this.map.fitBounds(bounds, {
        padding: { top: 10, bottom: 10, left: 10, right: 10 }
      })
    }
  }

  drawSelectedFire () {
    if (!this.state.mapboxLoaded) {
      // console.log('[map]', 'could not draw selected fire')
      return
    }

    // console.log('[map]', 'drawSelectedFire')

    const { fires, municipality, fireName } = this.props

    if (fires && municipality && fireName) {
      const fireMatches = fires.filter(fire => fire.id === fireName)

      if (fireMatches.length) {
        const fire = fireMatches[0]

        const diff = [
          fire.centroid.coordinates[0] - municipality.centroid.coordinates[0],
          fire.centroid.coordinates[1] - municipality.centroid.coordinates[1]
        ]

        const movedFirePolygon = geojsonTranslate(fire.polygon, diff)

        if (this.map.getLayer('currentFire')) {
          this.map.removeLayer('currentFire')
        }

        if (this.map.getSource('currentFire')) {
          this.map.removeSource('currentFire')
        }

        this.map.addLayer({
          id: 'currentFire',
          type: 'fill',
          source: {
            type: 'geojson',
            data: movedFirePolygon
          },
          layout: {},
          paint: {
            'fill-color': '#E51C30',
            'fill-opacity': 0.8
          }
        })

        // const bounds = new this.mapboxgl.LngLatBounds(
        //   geojsonExtent(movedFirePolygon)
        // )
        //
        // this.map.fitBounds(bounds, {
        //   padding: { top: 40, bottom: 40, left: 40, right: 40 }
        // })
      }
    }
  }

  render () {
    return <div class={styles.map} ref={elm => (this.elm = elm)} />
  }
}

export default SuggestSearch



// WEBPACK FOOTER //
// ./src/v1/components/Map/index.js